import React, { createContext, useContext, useState, useCallback } from 'react';
import { normalizarUsuario } from './usuarioAutenticado';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  
  const [currentUser, atualizarUsuario] = useState(() => {
    try { return normalizarUsuario(JSON.parse(localStorage.getItem('user') || 'null')); }
    catch { return null; }
  });
  const setCurrentUser = useCallback(user => atualizarUsuario(normalizarUsuario(user)), []);
  const isClient = Boolean(currentUser?.isClient);

  const logout = async () => {   
    localStorage.clear();
    sessionStorage.clear();
    setCurrentUser(null);
    return Promise.resolve();
  };

  const checkUserPermission = (requiredRole) => {
    if (!currentUser) {
      return false;
    }

    if (!requiredRole)
      return true;

    if ((currentUser.roles || []).includes('Master')) {
      return true;
    }

    return (currentUser.roles || []).includes(requiredRole);
  }

  const value = { currentUser, setCurrentUser, logout, checkUserPermission, isClient };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

